import React, { useEffect, useState } from 'react';
import { ExternalLink } from 'lucide-react';
import { fetchBatches } from '../../lib/api';

const BatchTimeline = () => {
  const [data, setData] = useState(null);
  useEffect(() => { fetchBatches().then(setData).catch(() => {}); }, []);

  if (!data)
    return <div data-testid="batches-loading" className="h-40 bg-[#C1D7E2]/40 animate-pulse" />;

  return (
    <div data-testid="batches-view" className="space-y-10">
      <header className="border-b border-[#C1D7E2] pb-6">
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#90B0BF] mb-2">
          Batch Timeline · Seed-to-Skin
        </p>
        <h3 className="font-serif text-3xl md:text-4xl text-[#7C9CB1] font-light">
          Every batch, in one ledger.
        </h3>
      </header>

      <div className="space-y-12">
        {data.batches.map((b, i) => (
          <article
            key={b.id}
            data-testid={`batch-${i}`}
            className="bg-[#F4F8F9] border border-[#C1D7E2] p-8"
          >
            <div className="flex flex-wrap items-start justify-between gap-6 mb-6">
              <div>
                <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#90B0BF]">
                  {b.id} · {b.status}
                </p>
                <h4 className="font-serif text-2xl md:text-3xl text-[#7C9CB1] font-light mt-1">
                  {b.name}
                </h4>
                <p className="font-mono text-[11px] tracking-[0.2em] text-[#90B0BF] mt-2">
                  {b.production_date} · chain hash {b.chain_hash}
                </p>
              </div>
              <a
                href={b.supplier_coa_url}
                target="_blank"
                rel="noreferrer"
                data-testid={`batch-${i}-coa`}
                className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.22em] uppercase border border-[#7C9CB1] text-[#7C9CB1] px-4 py-2 hover:bg-[#C1D7E2]/40 transition-colors"
              >
                Supplier COA <ExternalLink size={12} strokeWidth={1.5} />
              </a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
              <div className="md:col-span-5">
                <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#90B0BF] mb-3">
                  Ingredients
                </p>
                <ul className="divide-y divide-[#C1D7E2]">
                  {b.ingredients.map((ing) => (
                    <li key={ing.lot} className="py-2">
                      <p className="font-serif text-base text-[#7C9CB1]">{ing.name}</p>
                      <p className="font-mono text-[10px] text-[#90B0BF]">
                        {ing.supplier} · lot {ing.lot}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="md:col-span-7">
                <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#90B0BF] mb-3">
                  Milestones
                </p>
                <ol className="relative pl-6 border-l border-[#AAC6D4]">
                  {b.milestones.map((m) => (
                    <li key={m.hash} className="pb-4 last:pb-0 relative">
                      <span className="absolute -left-[28px] top-1 w-2.5 h-2.5 rounded-full bg-[#7C9CB1] ring-4 ring-[#F4F8F9]" />
                      <p className="font-serif text-base text-[#7C9CB1]">{m.step}</p>
                      <p className="font-mono text-[11px] text-[#90B0BF]">
                        {m.date} · {m.hash}
                      </p>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default BatchTimeline;
